import 'spart/css/spart.css';
import 'spart/css/component.css';
import './css/login.css';
import './css/home.css';
import './css/chat.css';

import './SVGs.js';
import { initializeApp } from 'page/login';

initializeApp({ isProgressiveWebApp: true }).then(() => {
	document.getElementById('app-loading-indicator').hidden = true;

	if ('serviceWorker' in navigator) {
		navigator.serviceWorker
			.register('/sw.js')
			.then(() => console.debug('Ready!'))
			.catch((err) => console.error('SW registration failed:', err));
	}
});
